import React from 'react';

const HelpItem6 = () => {
  return (
    <>
      <p className='p'>
        When you select the hobbyist page. A list of hobbyists will be listed.
      </p>
      <p className='p'>
        Each hobbyist with have a link to the restaurant they work for. Clicking
        on the restaurant name will give you the restaurant detail which
        includes menus, assocaites and entertainment items.
      </p>
      <p className='p'>
        The hobbyists that are in will have a green dot on their photo.
      </p>
    </>
  );
};

export default HelpItem6;
